//entrypoint
import axios from "axios";
import { getToken, getXOrigin } from "../utils/constants";
import bycrpt from "bcryptjs-react";

import store from "../redux/store";
const { dispatch } = store;

export const AXIOS_INSTANCE_WITHOUT_INTERCEPTOR = axios.create();
export async function generateHash() {
  const timestamp = Date.now().toString();
  const random = Math.random().toString();
  const hash = await bycrpt.hash(timestamp + random, 10);
  return hash;
}
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.request.use(async (config) => {
  const token = getToken();
  // config.headers["x-origin"] = '8fb6ec5f08b1ce5054410d6b1efe6b49';
  config.headers["x-origin"] = getXOrigin("all");
  const fp = localStorage.getItem("fingerprint");
  config.headers["x-browser-fingerprint"] = fp;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.response.use(
  (response) => {
    const token = getToken();
    if (response.headers.authorization && token) {
      dispatch({
        type: "accountData/setToken",
        payload: response?.headers?.authorization.replace("Bearer", ""),
      });
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      dispatch({ type: "accountData/logOut" });
      localStorage.clear();
      localStorage.removeItem("fingerprint");
      // window.location.href = "/login";
    }
    return error;
  }
);

export const AXIOS_INSTANCE = AXIOS_INSTANCE_WITHOUT_INTERCEPTOR;
